import { can } from '../permissions/policy';
import { createStore } from 'redux';

// Helper function to validate token (implement actual validation logic)
const isTokenValid = (token) => {
  if (!token) return false;
  
  // Option 1: Simple check if token exists and has minimum structure
  // return typeof token === 'string' && token.length > 10;
  
  // Option 2: Check token expiration if your token contains expiration
  try {
    // If using JWT tokens, you can decode and check expiration
    // const decodedToken = JSON.parse(atob(token.split('.')[1]));
    // return decodedToken.exp > Date.now() / 1000;
    
    // For now, let's just check if the token exists
    return !!token;
  } catch (e) {
    return false;
  }
};

// Initial state with validation
const getInitialState = () => {
  const storedUser = localStorage.getItem('user');
  const storedToken = localStorage.getItem('token');
  const storedViewMode = localStorage.getItem('viewMode');
  const storedArchiveViewMode = localStorage.getItem('archiveViewMode');
  
  let user = null;
  let token = null;
  let viewMode = 'vente'; // default to 'vente'
  let archiveViewMode = false; // default to false - permission-controlled toggle to view archived data
  
  try {
    user = storedUser ? JSON.parse(storedUser) : null;
    token = storedToken ? JSON.parse(storedToken) : null;
    viewMode = storedViewMode || 'vente';
    // Only restore archiveViewMode if the user can view archives
    archiveViewMode = storedArchiveViewMode === 'true' && can(user, 'archives');
    
    // If token is invalid, clear user as well
    if (!isTokenValid(token)) {
      user = null;
      token = null;
      archiveViewMode = false;
      // Clean up localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('archiveViewMode');
    }
  } catch (e) {
    // Handle parsing errors
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('archiveViewMode');
  }
  
  return {
    user,
    token,
    error: null,
    viewMode,
    archiveViewMode
  };
};

const initialState = getInitialState();

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'REFRESH_USER':
      localStorage.setItem('user', JSON.stringify(action.payload));
      return { ...state, user: action.payload, archiveViewMode: state.archiveViewMode && can(action.payload, 'archives') };
    case 'SET_USER':
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', JSON.stringify(action.payload.token));
      // Reset archiveViewMode if the new user cannot view archives
      if (!can(action.payload.user, 'archives')) {
        localStorage.removeItem('archiveViewMode');
        return { ...state, user: action.payload.user, token: action.payload.token, error: null, archiveViewMode: false };
      }
      return { ...state, user: action.payload.user, token: action.payload.token, error: null };
    case 'LOGIN_ERROR':
      return { ...state, error: action.payload };
    case 'LOGOUT':
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('archiveViewMode');
      return { ...state, user: null, token: null, error: null, archiveViewMode: false };
    case 'TOGGLE_VIEW_MODE':
      const newMode = state.viewMode === 'vente' ? 'achat' : 'vente';
      localStorage.setItem('viewMode', newMode);
      return { ...state, viewMode: newMode };
    case 'SET_VIEW_MODE':
      localStorage.setItem('viewMode', action.payload);
      return { ...state, viewMode: action.payload };
    case 'TOGGLE_ARCHIVE_VIEW_MODE':
      // Archive viewing requires the current read permission
      if (!can(state.user, 'archives')) {
        return state;
      }
      const newArchiveMode = !state.archiveViewMode;
      localStorage.setItem('archiveViewMode', newArchiveMode.toString());
      return { ...state, archiveViewMode: newArchiveMode };
    case 'SET_ARCHIVE_VIEW_MODE':
      // Archive viewing requires the current read permission
      if (!can(state.user, 'archives')) {
        return state;
      }
      localStorage.setItem('archiveViewMode', action.payload.toString());
      return { ...state, archiveViewMode: action.payload };
    default:
      return state;
  }
}

const store = createStore(reducer);

export default store;